import Image from "next/image";
import React from "react";

export interface EventAudienceCardData {
    title: string;
    description: string;
    image: string;
}

interface EventAudienceCardProps {
    data: EventAudienceCardData;
    lastItem: boolean;
}

const EventAudienceCard: React.FC<EventAudienceCardProps> = ({ data, lastItem }) => {
    const { title, description, image } = data;

    return (
        <article className={`mx-auto max-w-5xl flex flex-col md:flex-row gap-10 md:gap-20 py-10 md:py-20 ${!lastItem ? "border-b border-solid border-gray-200" : ""}`}>
            <div className="md:w-1/2">
                <Image src={image} alt={title} width={580} height={580} />
            </div>
            <div className="md:w-1/2 flex flex-col justify-center">
                <h3 style={{ fontFamily: "Degular Display", fontWeight: "700" }} className="text-5xl mb-5">
                    {title}
                </h3>
                <p className="text-xl font-medium font-inter" style={{ color: "rgba(26, 32, 44, 1)" }}>
                    {description}
                </p>
            </div>
        </article>
    );
};

export default EventAudienceCard;
